module.exports = __webpack_public_path__ + "img/Ceuta.5f80311a.svg";